import {
  Companion_getInstance10mviaqk2elyr as Companion_getInstance,
  EmailData2csvvu2p1bk3b as EmailData,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareEmailDataFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [EmailData_templateFile_getInstance(), EmailData_subjectLine_getInstance(), EmailData_variables_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function EmailData_templateFile$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function EmailData_templateFile$_get_name_$ref_6qqeas() {
  return (p0) => p0.k20();
}
function EmailData_templateFile$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EmailData_templateFile$_get_serializer_$ref_uresvx() {
  return (p0) => p0.j2j();
}
function EmailData_templateFile$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function EmailData_templateFile$_get_annotations_$ref_e3l3af() {
  return (p0) => p0.bz();
}
var EmailData_templateFileClass;
function EmailData_templateFile() {
  if (EmailData_templateFileClass === VOID) {
    class $ {
      constructor() {
        EmailData_templateFile_instance = this;
        var tmp = this;
        tmp.t5y_1 = lazy(EmailData_templateFile$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u5y_1 = lazy(EmailData_templateFile$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v5y_1 = lazy(EmailData_templateFile$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EmailData_templateFile$_get_name_$ref_6qqeas(), null);
        return tmp0.f2();
      }
      w5y(receiver) {
        return receiver.x5y_1;
      }
      m2j(receiver) {
        return this.w5y(receiver instanceof EmailData() ? receiver : THROW_CCE());
      }
      a5z(receiver, value) {
        return receiver.b5z(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof EmailData() ? receiver : THROW_CCE();
        return this.a5z(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EmailData_templateFile$_get_serializer_$ref_uresvx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v5y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EmailData_templateFile$_get_annotations_$ref_e3l3af(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'EmailData_templateFile', VOID, VOID, [SerializableProperty()]);
    EmailData_templateFileClass = $;
  }
  return EmailData_templateFileClass;
}
var EmailData_templateFile_instance;
function EmailData_templateFile_getInstance() {
  if (EmailData_templateFile_instance === VOID)
    new (EmailData_templateFile())();
  return EmailData_templateFile_instance;
}
function EmailData_subjectLine$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function EmailData_subjectLine$_get_name_$ref_nsjf64() {
  return (p0) => p0.k20();
}
function EmailData_subjectLine$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EmailData_subjectLine$_get_serializer_$ref_qow8ez() {
  return (p0) => p0.j2j();
}
function EmailData_subjectLine$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function EmailData_subjectLine$_get_annotations_$ref_8twcan() {
  return (p0) => p0.bz();
}
var EmailData_subjectLineClass;
function EmailData_subjectLine() {
  if (EmailData_subjectLineClass === VOID) {
    class $ {
      constructor() {
        EmailData_subjectLine_instance = this;
        var tmp = this;
        tmp.c5z_1 = lazy(EmailData_subjectLine$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d5z_1 = lazy(EmailData_subjectLine$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e5z_1 = lazy(EmailData_subjectLine$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.c5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EmailData_subjectLine$_get_name_$ref_nsjf64(), null);
        return tmp0.f2();
      }
      w5y(receiver) {
        return receiver.y5y_1;
      }
      m2j(receiver) {
        return this.w5y(receiver instanceof EmailData() ? receiver : THROW_CCE());
      }
      a5z(receiver, value) {
        return receiver.b5z(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof EmailData() ? receiver : THROW_CCE();
        return this.a5z(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EmailData_subjectLine$_get_serializer_$ref_qow8ez(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EmailData_subjectLine$_get_annotations_$ref_8twcan(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'EmailData_subjectLine', VOID, VOID, [SerializableProperty()]);
    EmailData_subjectLineClass = $;
  }
  return EmailData_subjectLineClass;
}
var EmailData_subjectLine_instance;
function EmailData_subjectLine_getInstance() {
  if (EmailData_subjectLine_instance === VOID)
    new (EmailData_subjectLine())();
  return EmailData_subjectLine_instance;
}
function EmailData_variables$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function EmailData_variables$_get_name_$ref_osidl7() {
  return (p0) => p0.k20();
}
function EmailData_variables$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EmailData_variables$_get_serializer_$ref_f9u3hu() {
  return (p0) => p0.j2j();
}
function EmailData_variables$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function EmailData_variables$_get_annotations_$ref_7n6aye() {
  return (p0) => p0.bz();
}
var EmailData_variablesClass;
function EmailData_variables() {
  if (EmailData_variablesClass === VOID) {
    class $ {
      constructor() {
        EmailData_variables_instance = this;
        var tmp = this;
        tmp.f5z_1 = lazy(EmailData_variables$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5z_1 = lazy(EmailData_variables$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5z_1 = lazy(EmailData_variables$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EmailData_variables$_get_name_$ref_osidl7(), null);
        return tmp0.f2();
      }
      w5y(receiver) {
        return receiver.z5y_1;
      }
      m2j(receiver) {
        return this.w5y(receiver instanceof EmailData() ? receiver : THROW_CCE());
      }
      i5z(receiver, value) {
        return receiver.b5z(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof EmailData() ? receiver : THROW_CCE();
        return this.i5z(tmp, (!(value == null) ? isInterface(value, KtMap()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EmailData_variables$_get_serializer_$ref_f9u3hu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EmailData_variables$_get_annotations_$ref_7n6aye(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'EmailData_variables', VOID, VOID, [SerializableProperty()]);
    EmailData_variablesClass = $;
  }
  return EmailData_variablesClass;
}
var EmailData_variables_instance;
function EmailData_variables_getInstance() {
  if (EmailData_variables_instance === VOID)
    new (EmailData_variables())();
  return EmailData_variables_instance;
}
//region block: exports
export {
  prepareEmailDataFields as prepareEmailDataFields2nhge48v440ey,
};
//endregion

//# sourceMappingURL=EmailDataFields.mjs.map
